import styled from 'styled-components';
import { SPACES } from 'common/constants/sizes';
import { StyledWidgetHeader } from 'components/base/common-styles';
import { getColor } from 'common/constants/_colors';

export const StyledDashboardHeader = styled(StyledWidgetHeader)`
  display: flex;
  justify-content: space-between;
  padding: ${SPACES.small};
  box-sizing: border-box;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  &.selected {
    border-left: 3px solid ${getColor('dodgerBlue')};
    color: ${getColor('dodgerBlue')};
  }
`;

export const StyledDashboardItem = styled(StyledWidgetHeader)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${SPACES.small};
`;
